import { render, staticRenderFns } from "./ContactDetailsUpdater.vue?vue&type=template&id=48f9f84b&"
import script from "./ContactDetailsUpdater.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports